import { render } from "./App.vue?vue&type=template&id=6f5d920f"
const script = {}

import "./App.vue?vue&type=style&index=0&id=6f5d920f&lang=less"

import exportComponent from "/Users/bld/web/doctor2/doctor-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__